<!-- Activity Tab with Timeline and Comment Section -->
<div class="activity-container" style="height: calc(85vh - 135px);">
    
    <!-- Loading State for Activities -->
    <div *ngIf="isLoadingActivities" class="loading-activities-container flex flex-col justify-center items-center h-full">
        <p-progressSpinner strokeWidth="3" styleClass="w-8 h-8" [style]="{'width': '60px', 'height': '60px'}"></p-progressSpinner>
        <div class="loading-text mt-4">
            <h4 class="text-lg font-medium text-gray-700 mb-2">Fetching Activities...</h4>
            <p class="text-sm text-gray-500">Please wait while we load the ticket activities</p>
        </div>
    </div>

    <!-- Timeline and Comment Section - Show only when not loading -->
    <div *ngIf="!isLoadingActivities" class="timeline-and-comment-container h-full">
        <!-- Timeline Section -->
        <div class="timeline-section" style="height: 100%;" #activityContainer>
            <app-ticket-timeline 
                [timelineData]="ticketTimeline"
                (editEvent)="onEditComment($event)"
                (deleteEvent)="onDeleteComment($event)">
            </app-ticket-timeline>
        </div>
        
        <!-- Comment Section -->
        <div class="comment-section" style="height: 10%;"
        [style]="{'margin-bottom': isTableView ? '-20px' : '-30px'}"
        >
            <div class="flex flex-col h-full">
                <label class="block mb-2 text-sm font-medium">Add Comment:</label>
                <div class="comment-input-container flex-1">
                    <textarea 
                        pTextarea 
                        class="comment-textarea" 
                        rows="3"
                        [(ngModel)]="newComment" 
                        placeholder="Type your comment here and press Enter to send..."
                        (keydown)="onKeyDown($event)">
                    </textarea>
                    <p-button 
                        icon="pi pi-send" 
                        class="send-button"
                        (click)="addComment()"
                        [disabled]="!newComment || !newComment.trim()"
                        title="Send Comment">
                    </p-button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Edit Comment Dialog -->
<p-dialog 
    [modal]="true" 
    [visible]="showEditDialog" 
    [breakpoints]="{ '1199px': '50vw', '575px': '90vw' }"
    closable="false" 
    [style]="{ width: '40vw' }" 
    [draggable]="false" 
    [resizable]="false">
    
    <ng-template pTemplate="header">
        <div class="flex items-center justify-center dialog-header w-full">
            Edit Comment
            <div class="absolute right-2">
                <button (click)="handleEditDialogClose()" class="outline-none p-2">
                    <i class="pi pi-times"></i>
                </button>
            </div>
        </div>
    </ng-template>

    <div class="dialog-content">
        <div class="flex flex-col gap-4">
            <label class="block text-sm font-medium">Comment:</label>
            <textarea 
                pTextarea 
                class="w-full" 
                rows="4"
                [(ngModel)]="editCommentText" 
                placeholder="Edit your comment..."
                [disabled]="isUpdatingComment">
            </textarea>
        </div>

        <div class="flex gap-4 mt-6 justify-end">
            <p-button
                label="Cancel"
                severity="secondary"
                variant="outlined"
                (click)="handleEditDialogClose()"
                [disabled]="isUpdatingComment">
            </p-button>

            <p-button
                label="Update"
                severity="primary"
                icon="pi pi-check"
                (click)="updateComment()"
                [disabled]="!editCommentText || !editCommentText.trim() || isUpdatingComment"
                [loading]="isUpdatingComment">
            </p-button>
        </div>
    </div>
</p-dialog>

<!-- Delete Comment Dialog -->
<p-dialog 
    [modal]="true" 
    [visible]="showDeleteDialog" 
    [breakpoints]="{ '1199px': '40vw', '575px': '90vw' }"
    closable="false" 
    [style]="{ width: '30vw' }" 
    [draggable]="false" 
    [resizable]="false">
    
    <ng-template pTemplate="header">
        <div class="flex items-center justify-center dialog-header w-full">
            Delete Comment
            <div class="absolute right-2">
                <button (click)="handleDeleteDialogClose()" class="outline-none p-2">
                    <i class="pi pi-times"></i>
                </button>
            </div>
        </div>
    </ng-template>

    <div class="dialog-content">
        <div class="text-center font-medium text-lg">
            Are you sure you want to delete this comment?
        </div>
        
        <div class="bg-gray-50 p-3 mt-4 rounded border-l-4 border-gray-400">
            <p class="text-sm text-gray-700">{{ selectedComment?.desc }}</p>
        </div>

        <div class="flex gap-4 mt-6 justify-end">
            <p-button
                label="Cancel"
                severity="secondary"
                variant="outlined"
                (click)="handleDeleteDialogClose()"
                [disabled]="isDeletingComment">
            </p-button>

            <p-button
                label="Delete"
                severity="danger"
                icon="pi pi-trash"
                (click)="deleteComment()"
                [disabled]="isDeletingComment"
                [loading]="isDeletingComment">
            </p-button>
        </div>
    </div>
</p-dialog>
